import { ReactNode } from 'react';

import { DiagramPanelLayout } from '@/components/layout/DiagramPanelLayout';

import { useEntityDiagramContext } from '../contexts/entityDiagram.context';

export interface EntityDiagramContextContainerProps {
  height: number;
  width: number;
  children: ReactNode;
}

export const EntityDiagramContextContainer = ({
  height,
  width,
  children,
}: EntityDiagramContextContainerProps) => {
  const { state } = useEntityDiagramContext();
  const { derivedData } = state;

  return (
    <DiagramPanelLayout
      isPanelOpen={derivedData.isSummaryPanelOpen}
      height={height}
      width={width}
    >
      {children}
    </DiagramPanelLayout>
  );
};
